module.exports = __webpack_public_path__ + "img/D10.57daef47.svg";